<ng-container [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzRequired]="isRequired">
      <p class="form-desc">
        In what settings or locations does this behavior usually occur? Select
        all that apply.
      </p>
    </nz-form-label>
    <div class="checkbox-wrapper">
      <span
        *ngFor="let env of behaviourEnvironmentList; trackBy: trackById"
        nz-checkbox
        [nzChecked]="
          form.get('caseBehaviorEnvironmentIds')?.value?.includes(env.id)
        "
        (nzCheckedChange)="
          onCheckboxChange('caseBehaviorEnvironmentIds', $event, env.id)
        "
        [nzValue]="env.id">
        {{ env.name }}
      </span>
    </div>
    <div
      class="ant-form-item-explain-error mt-3"
      *ngIf="form.get('caseBehaviorEnvironmentIds')?.hasError('required')">
      Please select at least 1 behavior environment.
    </div>
  </nz-form-item>
</ng-container>
